function printPerformanceData({ time }, type) {
    const style = 'font-size:25px;color:red;background:yellow;font-weight:bold;';
    console.log('%c%s', style, `__Performance__:` + type);
    console.table(time);
}

function isLocalDevelop() {
    return location.hostname === 'localhost' || location.host === '127.0.0.1';
}

export function checkStatusAndPrintPerformanceData(appStore, type) {
    if (isLocalDevelop() && console.group) {
        printPerformanceData(appStore.formatPerformanceData(), type);
    }
}